<template>
    <div class="kt-portlet__head kt-portlet__head--lg">
        <slot></slot>
    </div>
</template>
